import {Routes, Route} from 'react-router-dom';
import ClassificationIntro from "./ClassificationIntro";
import DecisionBoundary from "./DecisionBoundary";
import SigmoidFunction from "./SigmoidFunction"
import LogisticRegressionRoutes from "./LogisticRegression/LogisticRegressionRoutes";

const ClassificationRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<ClassificationIntro/>}/>
                <Route path="/decision-boundary" element={<DecisionBoundary/>}/>
                <Route path="/sigmoid-function" element={<SigmoidFunction/>}/>
                <Route path="/logistic-regression/*" element={<LogisticRegressionRoutes/>}/>
            </Routes>
        </>
    )
}

export default ClassificationRoutes;